import { BehaviorSubject } from "rxjs";
import config from "../../config/index";
import requestOptions from "@/helpers/RequestOptions";
import handleResponse from "@/helpers/HandleResponses";
import handleBlobResponse from "@/helpers/HandleBlobResponses";

export const paymentService = {
  paySalary,
  payPension,
  payTax,
  getTaxOffice,
  getPensionManager,
  getSalaryCategories,
  getSalarySubCategories,
  getSalaryElements,
  addSalaryElement,
  updateSalaryElement,
  removeSalaryElement,
  addSalarySubCategory,
  updateSalarySubCategory,
  removeSalarySubCategory,
  addSalaryGroup,
  updateSalaryGroup,
  removeSalaryGroup,
  getSalaryGroups,
  addSalaryGroupAttr,
  updateSalaryGroupAttr,
  removeSalaryGroupAttr,
  getSalaryGroupAttrs,
  getEmployeeSalaries,
  getEmployeeSalary,
  addEmployeeSalary,
  addEmployeeSalaries,
  updateEmployeeSalary,
  removeEmployeeSalary,
  copyFrom,
  groupFrom,
  percentageReview,
  generateSlip,
  getallPayslips,
  getallTempPayslips,
  getPayslip,
  getPayslipsByEmployee,
  downloadElementTemplate,
  downloadGroupTemplate,
  downloadGroupPayrollTemplate,
  downloadEmployeePayrollTemplate,
  downloadAssignGroupTemplate,
  exportSalaryGroupPayrolls,
  salaryReview,
  importElement,
  importGroup,
  importGroupPayroll,
  importEmployeePayroll,
  importAssignGroup,
  UpdateFromGroup,
  removeEmployeeSalaries,
  getSalaryProrateds,
  addSalaryProrated,
  getSalaryProrated,
  removeSalaryProrated,
  exportReport,
  postPayslipToView,
  refreshSlips
};

function paySalary(companyId) {
  return fetch(
    `${config.apiurl}/Payment/PaySalary?id=${companyId}`,
    requestOptions.post(null)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function payPension(companyId, period) {
  return fetch(
    `${config.apiurl}/Payment/PayPension?id=${companyId}&period=${period}`,
    requestOptions.post(null)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function payTax(companyId, period) {
  return fetch(
    `${config.apiurl}/Payment/PayTax?id=${companyId}&period=${period}`,
    requestOptions.post(null)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getTaxOffice(id) {
  return fetch(
    `${config.apiurl}/Payment/getTaxOffice?Id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function getPensionManager(id) {
  return fetch(
    `${config.apiurl}/Payment/getPensionManager?Id=${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getSalaryCategories() {
  return fetch(
    `${config.apiurl}/Salary/getSalaryCategories`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getSalarySubCategories(id) {
  return fetch(
    `${config.apiurl}/Salary/getSalarySubCategories/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getSalaryElements(id) {
  return fetch(
    `${config.apiurl}/Salary/getSalaryElements/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getSalaryGroups(id) {
  return fetch(
    `${config.apiurl}/Salary/getSalaryGroups/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getSalaryGroupAttrs(id) {
  return fetch(
    `${config.apiurl}/Salary/getSalaryGroupAttrs/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getEmployeeSalaries(id) {
  return fetch(
    `${config.apiurl}/Salary/getEmployeeSalaries/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getEmployeeSalary(id) {
  return fetch(
    `${config.apiurl}/Salary/getEmployeeSalariesByEmployee/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getallPayslips(id, month, year, status) {
  return fetch(
    `${config.apiurl}/Salary/GetAllPayslipByPeriod/${id}?month=${month}&year=${year}&status=${status}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getallTempPayslips(id) {
  return fetch(
    `${config.apiurl}/Salary/GetAllTempPayslipByPeriod/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getPayslip(id) {
  return fetch(`${config.apiurl}/Salary/GetPayslip/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function getPayslipsByEmployee(id) {
  return fetch(
    `${config.apiurl}/Salary/GetPayslipsByEmployee/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function salaryReview(id) {
  return fetch(
    `${config.apiurl}/Salary/SalaryReview/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function UpdateFromGroup(id) {
  return fetch(
    `${config.apiurl}/Salary/UpdateFromGroup/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addSalaryElement(req) {
  return fetch(`${config.apiurl}/Salary/PostElement`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateSalaryElement(req) {
  return fetch(
    `${config.apiurl}/Salary/UpdateSalaryElement`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeSalaryElement(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveSalaryElements/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addSalarySubCategory(req) {
  return fetch(
    `${config.apiurl}/Salary/PostSubCategory`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateSalarySubCategory(req) {
  return fetch(
    `${config.apiurl}/Salary/UpdateSalarySubCategory`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeSalarySubCategory(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveSalarySubCategory/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addSalaryGroup(req) {
  return fetch(`${config.apiurl}/Salary/PostGroup`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateSalaryGroup(id, req) {
  return fetch(
    `${config.apiurl}/Salary/UpdateSalaryGroup/${id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeSalaryGroup(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveSalaryGroup/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addSalaryGroupAttr(req) {
  return fetch(
    `${config.apiurl}/Salary/PostGroupAttr`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateSalaryGroupAttr(req) {
  return fetch(
    `${config.apiurl}/Salary/UpdateSalaryGroupAttr/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeSalaryGroupAttr(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveSalaryGroupAttr/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function addEmployeeSalary(req) {
  return fetch(
    `${config.apiurl}/Salary/PostEmployeeSalary`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function addEmployeeSalaries(req, recal) {
  return fetch(
    `${config.apiurl}/Salary/PostEmployeeSalaries?recalculate=${recal}`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function updateEmployeeSalary(req) {
  return fetch(
    `${config.apiurl}/Salary/UpdateEmployeeSalary/${req.id}`,
    requestOptions.put(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeEmployeeSalary(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveEmployeeSalary/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function removeEmployeeSalaries(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveEmployeeSalaries/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function copyFrom(req) {
  return fetch(`${config.apiurl}/Salary/CopyFrom`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function downloadElementTemplate(id) {
  return fetch(
    `${config.apiurl}/Salary/DownloadElementTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function downloadGroupTemplate() {
  return fetch(
    `${config.apiurl}/Salary/DownloadGroupTemplate`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadGroupPayrollTemplate(id) {
  return fetch(
    `${config.apiurl}/Salary/DownloadGroupPayrollTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadEmployeePayrollTemplate(id) {
  return fetch(
    `${config.apiurl}/Salary/DownloadEmployeePayrollTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function downloadAssignGroupTemplate(id) {
  return fetch(
    `${config.apiurl}/Salary/DownloadAssignGroupPayrollTemplate/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}
function exportSalaryGroupPayrolls(id) {
  return fetch(
    `${config.apiurl}/Salary/ExportSalaryGroupPayrolls/${id}`,
    requestOptions.get()
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function exportReport(id, req) {
  return fetch(
    `${config.apiurl}/Salary/ExportReport/${id}`,
    requestOptions.post(req)
  )
    .then(handleBlobResponse)
    .then(blob => {
      return blob;
    });
}

function importElement(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/Salary/importElement`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function importGroup(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/Salary/importGroup`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importGroupPayroll(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/Salary/importGroupPayroll`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importEmployeePayroll(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/Salary/importEmployeePayroll`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function importAssignGroup(companyId, file) {
  let formData = new FormData();
  formData.append("CompanyId", companyId);
  formData.append("File", file);
  return fetch(
    `${config.apiurl}/Salary/importAssignGroupPayroll`,
    requestOptions.postForm(formData)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function groupFrom(req) {
  return fetch(`${config.apiurl}/Salary/GroupFrom`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function percentageReview(req) {
  return fetch(`${config.apiurl}/Salary/PercentageReview`, requestOptions.post(req))
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function generateSlip(req) {
  return fetch(
    `${config.apiurl}/Salary/GeneratePayslip`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}

function getSalaryProrateds(id) {
  return fetch(
    `${config.apiurl}/Salary/GetSalaryProrateds/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function addSalaryProrated(req) {
  return fetch(
    `${config.apiurl}/Salary/PostEmployeeSalaryProrated`,
    requestOptions.post(req)
  )
    .then(handleResponse)
    .then(id => {
      return id;
    });
}
function getSalaryProrated(id) {
  return fetch(
    `${config.apiurl}/Salary/GetSalaryProrated/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function removeSalaryProrated(id) {
  return fetch(
    `${config.apiurl}/Salary/RemoveEmployeeSalaryProrated/${id}`,
    requestOptions.delete()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}

function postPayslipToView(id, month, year) {
  return fetch(
    `${config.apiurl}/Salary/PostPayslipByPeriod/${id}?month=${month}&year=${year}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}
function refreshSlips(id) {
  return fetch(
    `${config.apiurl}/Salary/RefreshSlips/${id}`,
    requestOptions.get()
  )
    .then(handleResponse)
    .then(model => {
      return model;
    });
}



// WEBPACK FOOTER //
// ./src/services/paymentService.js